module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/2-3-1-b5c12fe104682e6b8616f8e674ea495a.png";